export const NAME = 'folder';